import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import { Observable } from 'rxjs';
import { ICityGateItem } from '../../interfaces/city-gate.interface';

@Injectable({
  providedIn: 'root',
})
export class CityGatesService {
  constructor(
    private httpClient: HttpClient,
    private appSetting: AppSettings
  ) {}

  getCityGates(filters?: string): Observable<ICityGateItem[]> {
    const url = filters
      ? `${this.appSetting.cityGates.urls.base}?${filters}`
      : this.appSetting.cityGates.urls.base;
    return this.httpClient.get<ICityGateItem[]>(url);
  }
}

